import { EntityId } from './entityId';
import { Amount } from './amount';

export interface AssetTypeInstrument {
  assetType?: AssetTypeEnum;
}

export interface Instrument extends AssetTypeInstrument {
  id?: EntityId;
  isin?: string;
  ticker?: string;
  marketplace?: {
    shortName?: string;
    longName?: string;
  };
  description?: string;
  shortDescription?: string;
  remark?: string;
  subscriptionRule?: SubscriptionRuleEnum;
  endOfDayPrice?: {
    amount?: Amount;
    timestamp?: string;
  };
  currentPrice?: {
    amount?: Amount;
    timestamp?: string;
  };
  yieldToMaturity?: number;
  marketCapitalisation?: Amount;
  priceEarningsRatioEstimated?: number;
  turnover?: Amount;
  minimumTradingUnit?: number;
  isTradingAllowed?: boolean;
  watchlistId?: number;
  priceData?: {
    p1d?: PriceSeries;
    p1w?: PriceSeries;
    p1m?: PriceSeries;
    p3m?: PriceSeries;
    p6m?: PriceSeries;
    p1y?: PriceSeries;
    p5y?: PriceSeries;
  };
}

export type MarketPlace = Required<Instrument['marketplace']>;

export type PricePeriod = keyof Instrument['priceData'];

export const wizePricePeriods: Uppercase<PricePeriod>[] = ['P1W', 'P1M', 'P3M', 'P6M', 'P1Y', 'P5Y'];

export interface PriceSeries {
  source: string;
  currencyId: string;
  // TODO 29-Sept-2023/braune: date -> timestamp
  prices: { date: string; value: number }[];
}

export const AssetTypeEnum = {
  EQUITY: 'equity',
  MUTUAL_FUND: 'mutual fund',
  ETF: 'ETF',
  BOND: 'bond',
  COMMODITY: 'commodity',
  DERIVATIVE: 'derivative',
  GUARANTEE: 'guarantee',
  HEDGE_FUND: 'hedge fund',
  PRECIOUS_METAL: 'precious metal',
  PRIVATE_EQUITY: 'private equity',
  OTHER: 'other'
} as const;

export type InstrumentAssetTypeEnum = typeof AssetTypeEnum;
export type AssetTypeEnum = InstrumentAssetTypeEnum[keyof InstrumentAssetTypeEnum];

export const SubscriptionRuleEnum = {
  UNIT: 'UNIT',
  AMOUNT: 'AMOUNT',
  UNIT_OR_AMOUNT: 'UNIT_OR_AMOUNT'
} as const;

export type InstrumentSubscriptionRuleEnum = typeof SubscriptionRuleEnum;
export type SubscriptionRuleEnum = InstrumentSubscriptionRuleEnum[keyof InstrumentSubscriptionRuleEnum];

export enum AssetFilterEnum {
  ALL = 'ALL',
  EQUITIES = 'EQUITIES',
  ETFS = "ETF'S",
  BONDS = 'BONDS',
  MUTUAL_FUNDS = 'MUTUAL FUNDS'
}
